/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { setTitleHeader } from '@global/helpers';
import LoginScreen from '@/screens/LoginScreen';
import ResetPasswordScreen from '@/screens/ResetPasswordScreen';

const Stack = createStackNavigator();

const AuthNavigator = ({ navigation }) => {
  return (
    <Stack.Navigator
      initialRouteName="LoginScreen"
      screenOptions={(props) => ({
        headerShown: false,
      })}>
      <Stack.Screen
        name="LoginScreen"
        component={LoginScreen}
        options={{
          title: setTitleHeader('Login'),
        }}
      />
      <Stack.Screen
        name="ResetPasswordScreen"
        component={ResetPasswordScreen}
        options={{
          title: setTitleHeader('Login'),
        }}
      />
    </Stack.Navigator>
  );
};

export default AuthNavigator;
